export const attributeTypes = ['services', 'requirements']

export const services = [
  {
    key: 'lumperService',
    label: 'Lumper Service',
  },
  {
    key: 'palletJack',
    label: 'Pallet Jack',
  },
  {
    key: 'escortService',
    label: 'Escort Service',
  },
  {
    key: 'overnightParking',
    label: 'Overnight Parking',
  },
  {
    key: 'freezerBlast',
    label: 'Freezer Blast',
  },
  {
    key: 'driversLounge',
    label: 'Drivers Lounge',
  },
]

export const requirements = [
  {
    key: 'twicCard',
    label: 'TWIC Card',
  },
  {
    key: 'driverUnload',
    label: 'Driver Unload',
  },
]

export const allFacilityAttributes = [...requirements, ...services]

export const appointmentTypes = [
  {
    key: 'fcfs',
    label: 'First Come First Serve',
  },
  {
    key: 'notificationWindow',
    label: 'Notification Window',
  },
  {
    key: 'byWppointment',
    label: 'Appointment',
  },
]

export const facilitiesContactTypes = [
  {
    label: 'Primary Contact',
    key: 'primaryContact',
    ascendingSortOrder: 2,
  },
  {
    label: 'After-Hours Contact',
    key: 'afterHoursContact',
    ascendingSortOrder: 1,
  },
  {
    label: 'Other Contact',
    key: 'otherContact',
    ascendingSortOrder: 0,
  },
]

export const scheduleSlots = [
  {
    description: 'Monday to Friday',
    key: 'weekday',
  },
  {
    description: 'Saturday',
    key: 'saturday',
  },
  {
    description: 'Sunday',
    key: 'sunday',
  },
]

export const preferredSchedulingHours = {
  pickup: ['13:00', '14:00', '15:00', '16:00', '17:00'],
  delivery: ['6:00', '7:00', '8:00', '9:00', '10:00', '11:00'],
}

export const stopTypes = {
  pickup: 'Pickup',
  delivery: 'Deliver',
}
